import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import {provideRouter, Router, withInMemoryScrolling, withNavigationErrorHandler} from '@angular/router';

import {routes} from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {httpErrorInterceptor} from '@core/interceptors/http-error.interceptor';
import {loadingInterceptor} from '@core/interceptors/loading.interceptor';
import {companyHeaderInterceptor} from '@core/interceptors/company-header.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withNavigationErrorHandler((error) => {
      const router = inject(Router);
      router.navigate(['/error']);
    }),
      withInMemoryScrolling({scrollPositionRestoration: 'enabled'})
    ),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([companyHeaderInterceptor, loadingInterceptor, httpErrorInterceptor])),
    importProvidersFrom([
      // NbThemeModule.forRoot({name: 'dark'}),
      // NbDialogModule.forRoot(),
      // NbDatepickerModule.forRoot(),
      // NbDateFnsDateModule.forRoot({}),
      // NbEvaIconsModule
    ]),
  ]
};
